import React from 'react';
import { Dialog, IconButton, makeStyles, Typography } from '@material-ui/core';
import { CloseIcon } from '../../../../../components/Icon';
import { i18n } from '../../../../../language';
import { RoleEditTable } from '../../Table';

const useStyles = makeStyles((theme) => ({
  dialog: {
    '& .MuiPaper-root': {
      padding: '0',
      margin: '0',
      boxShadow: 'unset',
    },
  },
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '75.813rem',
    borderRadius: '0.625rem',
    boxShadow: '0 -2px 21px 0 rgba(30, 56, 140, 0.18)',
    backgroundColor: '#fff',
    overflow: 'auto',
  },
  headerTitle: {
    fontFamily: 'NotoSans-Bold',
    fontSize: '1.5rem',
    fontWeight: 'bold',
    color: '#2e4469',
  },
  roleName: {
    fontFamily: 'NotoSans-Bold',
    fontSize: '1.25rem',
    fontWeight: 'bold',
    color: '#2e4469',
    margin: '0 0 0.938rem 1.313rem',
    padding: '0 1.563rem',
    textDecoration: 'underline',
  },
  closeIcon: {
    fontSize: '1.375rem',
    color: '#538fff',
    margin: '-12px -12px 0 0',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '2.375rem 2.188rem 1.875rem 1.563rem',
  },
}));

export default function RoleEdit({ closePop, open, allData, updatePerMissionIds }) {
  const { roleName } = allData;
  const classes = useStyles();

  return (
    <Dialog open={open} maxWidth={false} className={classes.dialog}>
      <div className={classes.root}>
        <div className={classes.header}>
          <Typography className={classes.headerTitle}>{i18n.t('SETTING_EDIT_FUNCTION_AVAILABILITY')}</Typography>
          <IconButton id="setting_role_pop_clone" className={classes.closeIcon} onClick={closePop}>
            <CloseIcon />
          </IconButton>
        </div>
        <Typography className={classes.roleName}>{roleName}</Typography>
        <RoleEditTable allData={allData} updateInputValue={updatePerMissionIds} />
      </div>
    </Dialog>
  );
}
